export default __webpack_public_path__ + "static/media/slash-bell.91c1062e.svg";